import { useHistory } from 'react-router';
import './ModalWindow.scss';

const Modal = ({ show, children }) => {
  const showHideClassName = show ? 'modal display-block' : 'modal display-none';
  const history = useHistory();

  const onHandleClick = (e) => {
    if (e.target === e.currentTarget)
      history.push(history.goBack());

  }

  return (
    <div onClick={onHandleClick} className={showHideClassName}>
      <section onClick={onHandleClick} className='modal-main'>
        {children}
      </section>
    </div>
  );
};

export default Modal;